import { getEndpoint } from "@api-routes/endpoint";

const EIR_CUSTOMERS_FACADE_MS_NAME = "eir-customers-facade";

export const getSimCardsRequestRoute = (searchParams: string) =>
    `${getEndpoint(EIR_CUSTOMERS_FACADE_MS_NAME)}sim-swap/sim-cards-requests?${searchParams}`;

export const getSimSwapChargesRoute = (serviceId: number) =>
    `${getEndpoint(EIR_CUSTOMERS_FACADE_MS_NAME)}sim-swap/sim-cards/charges?serviceId=${serviceId}`;

export const getOrderSimRoute = () => `${getEndpoint(EIR_CUSTOMERS_FACADE_MS_NAME)}sim-swap/sim-cards/order`;

export const getActiveNewSimRoute = () => `${getEndpoint(EIR_CUSTOMERS_FACADE_MS_NAME)}sim-swap/sim-cards/activate`;

export const getServiceWithESimToActivateListRoute = () => `${getEndpoint(EIR_CUSTOMERS_FACADE_MS_NAME)}my-esim`;

export const getESimSwapRoute = () => `${getEndpoint(EIR_CUSTOMERS_FACADE_MS_NAME)}sim-swap/esim/swap`;

export const getRecommendationBannerRoute = () => `${getEndpoint(EIR_CUSTOMERS_FACADE_MS_NAME)}recommendations`;

export const closeRecommendationBannerRoute = () =>
    `${getEndpoint(EIR_CUSTOMERS_FACADE_MS_NAME)}recommendations/opt-out`;

export const getFeatureFlagRoute = () => `${getEndpoint(EIR_CUSTOMERS_FACADE_MS_NAME)}feature-switches`;

export const getCancelBroadbandEligibilityRoute = (orderReference: string) =>
    `${getEndpoint(EIR_CUSTOMERS_FACADE_MS_NAME)}eligibility/orders/${orderReference}/cancel-broadbands`;

export const postCancelBroadbandRoute = (orderReference: string) =>
    `${getEndpoint(EIR_CUSTOMERS_FACADE_MS_NAME)}orders/${orderReference}/cancel-broadbands`;

export const getAppointmentListRoute = () => `${getEndpoint(EIR_CUSTOMERS_FACADE_MS_NAME)}appointments`;

export const getAvailableAppointmentDateListRoute = (appointmentId: number) =>
    `${getEndpoint(EIR_CUSTOMERS_FACADE_MS_NAME)}appointments/${appointmentId}/available-dates`;

export const getRescheduleAppointmentEligibilityRoute = (appointmentId: number) =>
    `${getEndpoint(EIR_CUSTOMERS_FACADE_MS_NAME)}eligibility/appointments/${appointmentId}/reschedule`;

export const patchUpdateAppointmentRoute = (appointmentId: number) =>
    `${getEndpoint(EIR_CUSTOMERS_FACADE_MS_NAME)}appointments/${appointmentId}`;
